import { hasSubMenuItemName } from '../../../SubMenu'

export function isAsyncTableSubOutOfSubMenu({ sub, subMenu }) {
  return subMenu.length > 0 && !hasSubMenuItemName(subMenu, sub)
}
